import React from 'react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import '../../styles/public-portal.css';

export default function PublicLayout({ children }: { children: React.ReactNode }) {
  return <div className="public-portal"><div className="app-shell"><PublicHeader/><main>{children}</main><PublicFooter/></div></div>;
}
